import type { ComponentPropsWithoutRef } from 'react';

import { Image } from '@zoomit/primitives';
import { Flex } from '@zoomit/primitives';
import { Typography, cssVar, theme } from '@zoomit/zoomit-ds';

import { BaseMediaUrl } from '../../constants/apis';
import type { BaseImageType } from '../../types/shared';

type Props = {
  variant?: 'default' | 'elliptic';
  hegith: number;
  sponsorName: string;
  sponsorLogo: BaseImageType;
} & Omit<ComponentPropsWithoutRef<typeof Typography>, 'variant'>;

const ExternalIcon = (props: Props) => {
  const { hegith, sponsorName, sponsorLogo, variant = 'default', ...rest } = props;
  const widthAccordingToHeight = ((sponsorLogo.width as number) * hegith) / (sponsorLogo.height as number);
  return (
    <Flex gap={0.4} alignItems="center">
      <Image
        alt={sponsorName}
        src={`${BaseMediaUrl}/${sponsorLogo.id}`}
        blurDataURL={sponsorLogo.preview}
        width={widthAccordingToHeight}
        placeholder="blur"
        height={hegith}
        style={{ objectFit: 'contain' }}
      />
      <Typography
        className="color-exception-sponsor-name"
        variant="subhead"
        textColor={variant === 'default' ? cssVar(theme.grey1) : cssVar(theme.white)}
        {...rest}
      >
        {sponsorName}
      </Typography>
    </Flex>
  );
};

export default ExternalIcon;
